// Утилиты для работы с Telegram WebApp

export const isTelegramWebApp = () => {
    return !!(window.Telegram?.WebApp?.initData && window.Telegram.WebApp.initData.length > 0);
};

export const getTelegramUser = () => {
    if (isTelegramWebApp()) {
        return window.Telegram?.WebApp?.initDataUnsafe?.user;
    }
    return null;
};

export const getTelegramInitData = () => {
    if (isTelegramWebApp()) {
        return window.Telegram?.WebApp?.initData;
    }
    return null;
};
